import { inject, Injectable } from '@angular/core';

import { forkJoin, map, Observable } from 'rxjs';

import { InitializationResult, UserInitialization } from '@core/models/user-initialization.interface';

import { ClinicianDashboardApiService } from './clinician-dashboard-api.service';

@Injectable({
  providedIn: 'root',
})
export class ClinicianInitializationService implements UserInitialization {
  private readonly clinicianDashboardService = inject(ClinicianDashboardApiService);

  public initialize(): Observable<InitializationResult> {
    return forkJoin({
      clinicianDashboard: this.clinicianDashboardService.getClinicianDashboard(),
      avatar: this.clinicianDashboardService.getClinicianAvatar(),
    }).pipe(
      map(({ clinicianDashboard, avatar }) => ({
        clinicianDashboard,
        avatarUrl: URL.createObjectURL(avatar),
      })),
    );
  }
}
